import { notificationService } from '@/services/api/notification.service';
import { notificationModel } from '@/models/api/notification.model';
import { sharedHelper, alertHelper } from '@/utils';
import i18n from '@/i18n';

export const NOTIFICATION_MODULE = 'api/notification';
export const GET_ALL_NOTIFICATION = 'getAllNotification';
export const CREATE_NOTIFICATION = 'createNotification';
export const GET_NOTIFICATION = 'getNotification';
export const UPDATE_NOTIFICATION = 'updateNotification';

export const state = {
    list: {
        data: [],
        pagination: { pageNumber: 1, pageSize: 15, lastPage: 1, tableRowsCounts: 0, total: 0 },
    },
    details: {},
    status: { list: true, detail: true, save: true },
};

export const actions = {
    async [GET_ALL_NOTIFICATION]({ commit }, { filter }) {
        commit('requesting');
        try {
            const result = await notificationService.getAll(filter);
            commit('listSuccess', result);
            return result;
        } catch (error) {
            commit('failure');
            alertHelper.alertError({
                message: sharedHelper.getErrorMessage(error),
                title: i18n.t('message.error'),
            });
            return null;
        }
    },
    async [CREATE_NOTIFICATION]({ commit, dispatch }, { data, filter }) {
        commit('requesting', 'save');
        try {
            const result = await notificationService.store(data);
            commit('success');
            alertHelper.alertSuccess({ message: i18n.t('message.createXSuccess', [i18n.t('module.notification')]) });
            await dispatch(GET_ALL_NOTIFICATION, { filter });
            return result;
        } catch (error) {
            commit('failure');
            alertHelper.alertError({ message: sharedHelper.getErrorMessage(error), title: i18n.t('message.error') });
            return null;
        }
    },
    async [GET_NOTIFICATION]({ commit }, { uuid }) {
        commit('requesting', 'detail');
        try {
            const result = await notificationService.show(uuid);
            commit('detailSuccess', result);
            return result;
        } catch (error) {
            commit('failure');
            alertHelper.alertError({ message: sharedHelper.getErrorMessage(error), title: i18n.t('message.error') });
            return null;
        }
    },
    async [UPDATE_NOTIFICATION]({ commit, dispatch }, { data, filter }) {
        commit('requesting', 'save');
        try {
            const result = await notificationService.update(data);
            commit('success');
            alertHelper.alertSuccess({ message: i18n.t('message.updateXSuccess', [i18n.t('module.notification')]) });
            await dispatch(GET_ALL_NOTIFICATION, { filter });
            return result;
        } catch (error) {
            commit('failure');
            alertHelper.alertError({ message: sharedHelper.getErrorMessage(error), title: i18n.t('message.error') });
            return null;
        }
    },
};

export const mutations = {
    requesting(state, type = 'list') {
        state.status[type] = false;
    },
    listSuccess(state, result) {
        state.list.data = (result?.data || []).map(notificationModel);
        state.list.pagination = sharedHelper.apiPaginationAdapter(result?.pagination || {});
        state.status.list = true;
    },
    detailSuccess(state, result) {
        const payload = result?.data?.notification || result?.data || result?.notification || result || {};
        state.details = notificationModel(payload);
        state.status.detail = true;
    },
    success(state) {
        state.status = { list: true, detail: true, save: true };
    },
    failure(state) {
        state.status = { list: true, detail: true, save: true };
    },
};
